module.exports = __webpack_public_path__ + "img/ownersAppLogoDefault.cdd7fbb3.jpg";